import Radio from './radio';

export type { RadioSize } from './radio';
export default Radio;
